module.exports = __webpack_public_path__ + "media/forbes-728cf6ab.svg";